import React from 'react';
import { Space, Tooltip } from '@bedrock/components';
import { ChevronRight, HelpCircle } from '@bedrock/icons-react';
import styles from "./index.less"
import classNames from 'classnames/bind';
import classnames from 'classnames';
import { noop } from '@bedrock/components/lib/utils';

const cx = classNames.bind(styles)

type Props = {
    title?: React.ReactNode
    tip?: React.ReactNode
    operator?: React.ReactNode
    content?: React.ReactNode
    bottom?: React.ReactNode
    right?: React.ReactNode
    style?: React.CSSProperties
    operatorClick?: () => void;
    className?: string;
    backgroundColor?: 'blue' | 'yellow';
}

const PurpleCard = (props: Props) => {
    const { title, style, tip, operator, content, bottom, right, operatorClick = noop, className, backgroundColor = 'blue' } = props

    return (
        <div style={{ ...style }}  className={
            classnames(cx('purple-card'), { [cx('yellow-background')]: backgroundColor === 'yellow' }, className)}
        >
            <Space direction='vertical' align='stretch' size={4}>
                <Space className={cx('title-container-body')} >
                    <Space size={4} align='center'>
                        <div className={cx('title')}>
                            {title}
                        </div>
                        {tip && <Tooltip title={tip}>
                            <HelpCircle style={{ color: '#878A99' }} size={14} />
                        </Tooltip>}
                    </Space>
                    {operator && <div
                        className={cx('update-record')}
                        onClick={operatorClick}
                    >
                        <Space size={2}>{operator} < ChevronRight /></Space>
                    </div>}
                </Space>
                <div className={cx('content')}>
                    {content}
                </div>
                {bottom && <div className={cx('bottom-container')}>{bottom}</div>}
            </Space>
            {right && <div className={cx('right-icon')}>
                {right}
            </div>}
        </div>
    )
}

export default PurpleCard;